__turbopack_context__.v({
  "agent_headshot": "styles-module-scss-module___ZGlaa__agent_headshot",
  "button_container": "styles-module-scss-module___ZGlaa__button_container",
  "container": "styles-module-scss-module___ZGlaa__container",
});
